export type SectionFourItem = {
  itemNoVersionId: string;
  sequenceNumber: number;
  createDate?: string;
  updateDate?: string;
  itemPartOne: {
    constructionControlInfo: string;
    isDefects: boolean;
    defectDescriptionText?: string | null;
    defectsAbsenceRecord?: string | null;
    defectFixingPlanDate?: string | null;
    defectRecordDate?: string | null;
    controlEventPeriod?: {
      beginDate?: string;
      endDate?: string;
    };
    inspectionEmployee: {
      firstName: string;
      surname: string;
      middleName: string;
      position: string;
    } | null;
  };
};

export type SectionFourRow = {
  key: string;
  sequenceNumber: number;
  info: string;
  defect: string;
  itemInfo: any;
};

export const getSectionFourDataSource = (
  section4List: SectionFourItem[],
): SectionFourRow[] => {
  return section4List.map((item) => {
    const partOne = item.itemPartOne;
    const defect = partOne.isDefects
      ? (partOne.defectDescriptionText ?? "-")
      : (partOne.defectsAbsenceRecord ?? "-");

    return {
      key: item.itemNoVersionId,
      sequenceNumber: item.sequenceNumber,
      info: partOne.constructionControlInfo,
      defect,
      itemInfo: item,
    };
  });
};
